import React from "react";
import { Row, Container, Col } from "react-bootstrap";
import {
  BuildIcon,
  DesignIcon,
  LaunchIcon,
  MaintenanceIcon,
  PlaneIcon,
  TestIcon,
} from "../../../app-constants";

import { Link } from "gatsby";

const WorkFlow = [
  {
    logo: PlaneIcon,
    title: "Project Discovery",
    description: "Pinpoint retail needs and define clear development goals.",
    count: "01",
  },
  {
    logo: DesignIcon,
    title: "Tech Stack Selection",
    description:
      "Select the best tech for inventory, CRM, and payment integration.",
    count: "02",
  },
  {
    logo: BuildIcon,
    title: "UI/UX Design",
    description: "Design intuitive interfaces for customers and managers.",
    count: "03",
  },
  {
    logo: LaunchIcon,
    title: "App Development",
    description:
      "Develop core features like product catalog, payment systems, and real-time updates.",
    count: "04",
  },
  {
    logo: TestIcon,
    title: "Quality Assurance",
    description:
      "Test for performance, security, and multi-device compatibility.",
    count: "05",
  },
  {
    logo: MaintenanceIcon,
    title: "Deployment & Support",
    description: "Launch and provide ongoing updates for optimal performance.",
    count: "06",
  },
];
const Workflow = () => {
  return (
    <div className="workflow p-100" style={{ backgroundColor: "#F9F9F9" }}>
      <Container>
        <Row>
          <Col
            xs={12}
            md={10}
            lg={9}
            xl={8}
            xxl={8}
            className="m-auto text-center"
          >
            <h2>
              Accelerated <span>Retail App</span> Development Process for
              Maximum Efficiency
            </h2>
            <p>
              Our retail app development company follows a highly optimized,
              agile approach to deliver retail apps that are scalable, secure,
              and tailored to meet the fast-paced demands of modern retail. From
              initial concept to deployment, our process ensures every aspect of
              your retail app is built for performance, integration, and user
              engagement.
            </p>
          </Col>
        </Row>
        <Row className="workflow_secion">
          {WorkFlow.map((item, index) => (
            <Col xs={12} md={6} lg={4} xl={4} xxl={4} className="my-auto">
              <div className="workflow_items">
                <div className="item_name">
                  <span>{item.count}</span>
                  {item.title}
                  <div className="item_icon"> {item.logo}</div>
                </div>
                <p>{item.description}</p>
              </div>
            </Col>
          ))}
        </Row>
        <Row>
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="m-auto text-center mt-5"
          >
            <Link
              style={{ background: "#f47a1f", color: "#fff" }}
              to="/contact"
              className="border_btn"
              aria-label="TekRevol Contact"
            >
              Talk To Our Experts
            </Link>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Workflow;
